import { gtmEvent } from '@/composables/gtm/useGtm';

export const fireSessionLandingPage = (): void => {
  const existingLandingPage = sessionStorage.getItem('session_landing_page');
  if (existingLandingPage) return;
  const landingPath = window.location.pathname.replace(/\/+$/, '') || '/';

  gtmEvent().trackEvent({
    event: 'sessionLandingPage',
    landing_path: landingPath,
  });

  sessionStorage.setItem('session_landing_page', landingPath);
};

export const fireInitialTracking = (): void => {
  gtmEvent().customPageView();
};
